import { cn } from "../../cn";
import { useBaseUrl } from "../useBaseUrl";
import { IconType } from "./types";

export default function Icon({
  icon,
  className,
  size = "md",
  dynamicColor = true,
  ...props
}: {
  /**  Name of the icon to use */
  icon: IconType;
  /** Size of the icon (`sm` corresponds to a size of 16px and `md` a size of 24px) */
  size?: "sm" | "md";
  dynamicColor?: boolean;
} & React.ImgHTMLAttributes<HTMLImageElement>) {
  const isSmall = size === "sm";
  const baseUrl = useBaseUrl();

  if (dynamicColor) {
    return (
      <span
        className={cn(
          isSmall ? "size-4" : "size-6",
          "bg-black inline-block",
          className,
        )}
        style={{
          maskImage: `url(${baseUrl}/icons/${icon}${isSmall ? "_sm" : ""}.svg)`,
          maskSize: "100%",
          maskRepeat: "no-repeat",
          maskPosition: "center",
        }}
        {...props}
      />
    );
  }

  return (
    <img
      className={cn(isSmall ? "size-4" : "size-6", className)}
      src={`${baseUrl}/icons/${icon}${isSmall ? "_sm" : ""}.svg`}
      style={{ background: "transparent" }}
      {...props}
    />
  );
}
